import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AgeGate from "@/components/AgeGate";
import RegionalBanner from "@/components/RegionalBanner";
import { useSite } from "@/context/SiteContext";

export default function Layout() {
  const { consented } = useSite();
  return (
    <div className="grain min-h-screen flex flex-col">
      {!consented && <AgeGate />}
      <RegionalBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
